<div class="modal-header">
  <h3 class="modal-title">{{modalTitle}}</h3>
  <div class="header-actions">
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<div class="modal-body">
  <table class="gt-reclass-table table table-hover table-bordered table-striped table-condensed custom-table">
    <thead>
      <tr>
        <th></th>
        <th style="text-align: center;">Edit</th>
        <th style="text-align: center;">Delete</th>
        <th>Adjustment Description</th>
        <th>Adjustment Type</th>
        <th>Last Updated</th>
        <th>Updated By</th>
      </tr>
    </thead>
    <tbody>
      @for (item of dividends_data; track $index) {
<tr>
        <td class="text-center" style="font-size: 20px;"><i class="fa fa-plus-circle"></i></td>
        <td class="text-center"><a href=""><i class="fa fa-pencil"></i> Edit</a></td>
        <td class="text-center" style="font-size: 20px;"><a href=""><i class="fa fa-times"></i></a></td>
        <td>{{item.adj_des}}</td>
        <td>{{item.adj_type}}</td>
        <td>{{item.last_upd}}</td>
        <td>{{item.upd_by}}</td>
      </tr>
}
    </tbody>
  </table>
</div>
